import getRouteName from "../routes/routeToRouteNameMap";

const DOMAINS = {
  SITE: "site",
  ROOT: "",
};

const useURL = () => {
  const hostname = window.location.hostname;
  const resolvedHost =
    hostname === "127.0.0.1" || hostname.endsWith(".local")
      ? "localhost"
      : hostname;
  const path = window.location.pathname;
  const pathSegments = path.split("/");
  const firstPathSegment = pathSegments[1];
  const secondPathSegment = pathSegments[2];

  let isProxy = false;
  let dossierNr = null;
  let title = null;
  let URLDomain = null;
  let faviconPath = null;

  switch (resolvedHost) {
    case "awtech.be":
    case "www.awtech.be":
      isProxy = true;
      dossierNr = 70;
      URLDomain = "";
      title = "AW-Tech";
      faviconPath = "/favicon.ico";
      break;

    case "portal.welda.be/welda":
      isProxy = true;
      dossierNr = 10;
      URLDomain = "";
      title = "Welda";
      faviconPath = `/favicon.ico`;
      break;

    case "portal.welda.be":
    case "develop.welda.be":
    case "localhost":
      isProxy = false;
      if (firstPathSegment === DOMAINS.SITE) {
        dossierNr =
          new Map([
            ["10", 10],
            ["70", 70],
            ["15", 15],
          ]).get(secondPathSegment) ?? null;
      } else if (firstPathSegment === DOMAINS.ROOT) {
        dossierNr = 10;
      } else {
        dossierNr = null;
      }
      const routeName = getRouteName(path);
      title = `WGP - ${routeName ? routeName : path} `;
      URLDomain =
        new Map([
          [DOMAINS.SITE, "/site"],
          [DOMAINS.ROOT, "/"],
        ]).get(firstPathSegment) ?? null;

      title = title;
      faviconPath = `/${dossierNr}/favicon.ico`;
      break;

    default:
      dossierNr = null;
      URLDomain = null;
      title = "Not a valid URL";
      faviconPath = null;
      break;
  }
  const URLPrefix = `${isProxy ? "/" : `${URLDomain}/${dossierNr}/`}`;
  return {
    isProxy,
    URLDomain,
    dossierNr,
    URLPrefix,
    title,
    faviconPath,
    path,
  };
};

export default useURL;
